import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { memo, useMemo } from 'react';
import { JsonLd } from 'react-schemaorg';
import type { WithContext, VideoObject } from 'schema-dts';

import { withErrorBoundary } from '../ErrorBoundary';

import type { EditorialContent } from '@cobalt/utilities';
import { getVideoUrl } from '@services/LinkRuleService';

dayjs.extend(duration);

const fallbackImg = `${window.imgBaseUrl}/imgml/uefacom/${window.competitionFolder}/fallback.jpg`;

const VideoJsonLd = ({ video }: { video: EditorialContent }) => {
  const videoData: WithContext<VideoObject> = useMemo(() => {
    const embedUrl = getVideoUrl(video.id);
    const thumbnailUrl =
      video.mainMedia?.image?.square?.[`s4`] || video.imageUrl?.replace('w1.jpg', `s4.jpg`) || fallbackImg;

    return {
      '@context': 'https://schema.org',
      '@type': 'VideoObject',
      caption: video.title,
      name: video.title || 'UEFA.com',
      description: video.description || video.title || 'UEFA.com',
      embedUrl,
      contentUrl: video.hlsStreamUrl,
      duration: dayjs.duration(video.duration || 30, 's').toISOString(),
      datePublished: video.publicationDate ? dayjs(video.publicationDate).toISOString() : new Date().toISOString(),
      thumbnailUrl,
      uploadDate: video.publicationDate ? dayjs(video.publicationDate).toISOString() : new Date().toISOString(),
      author: {
        '@type': 'Organization',
        name: 'UEFA',
        url: location.origin,
      },
      publisher: {
        '@type': 'Organization',
        name: 'UEFA',
        url: location.origin,
      },
    };
  }, [video]);

  return <JsonLd item={videoData} />;
};

export default memo(withErrorBoundary(VideoJsonLd));
